import Api from '../Base'

class PatchMoveCluster extends Api {
  requestUrl = `/api/SpaceAssignment/${this.getParams().spaceAssignmentId}/MoveCluster`

  method = 'PATCH'
}

export default PatchMoveCluster
